// Libs
import { SWRResponse } from 'swr';
import axios, { AxiosError, AxiosResponse } from 'axios';
// App
import { PLAN_URL } from './plan.constants';
import { PlanDetails } from './plan.interfaces';
import { API_COMMON_BASE_URL } from '../../utils/api.constants';
import { useSWRAxiosGetRequest } from '../../utils/swr-axios-request.hooks';

/**
 * Get all plans api hook
 */
export const useGetPlans = (shouldFetch = true): SWRResponse<PlanDetails[], AxiosError> => {
  const urlOptional = shouldFetch ? `${API_COMMON_BASE_URL}/${PLAN_URL}` : null;

  return useSWRAxiosGetRequest(urlOptional, { revalidateOnFocus: false });
};

/**
 * Get all plans api
 */
export const getPlans = (): Promise<AxiosResponse<PlanDetails[]>> => {
  const url = `${API_COMMON_BASE_URL}/${PLAN_URL}`;

  return axios.get(url);
};
